/**
 * Nimizo × Trustyy Reviews — rewrite inline yellow/olive accents to brand coral.
 * Trustyy sets many colors via inline style attributes; CSS alone can't always win.
 */
(function () {
  var CORAL = '#FF6B81';
  var CORAL_SOFT = '#FFD0D7';
  var CORAL_SOFT_RGBA = 'rgba(255,107,129,0.18)';
  /* Trustyy yellows + empty-star pale gold + olive accents */
  var YELLOWS =
    /#DECB21[0-9A-Fa-f]{0,2}|#decb21[0-9A-Fa-f]{0,2}|#FFF2AA|#fff2aa|#FFEB9A|#ffeb9a|#F5E6A3|#f5e6a3|#8A5B00|#8a5b00|#393303|rgb\(\s*222\s*,\s*203\s*,\s*33\s*\)|rgb\(\s*255\s*,\s*242\s*,\s*170\s*\)/gi;

  function mapColor(m) {
    if (/393303|8A5B00/i.test(m)) return CORAL;
    /* Empty stars + progress tracks → coral (user wants red, not pale gold) */
    if (/FFF2AA|FFEB9A|F5E6A3|255\s*,\s*242\s*,\s*170/i.test(m)) return CORAL;
    if (/^#DECB21[0-9A-Fa-f]{2}$/i.test(m)) return CORAL_SOFT_RGBA;
    return CORAL;
  }

  function paint(el) {
    if (!el || el.nodeType !== 1) return;

    if (el.hasAttribute && el.hasAttribute('style')) {
      var style = el.getAttribute('style') || '';
      if (YELLOWS.test(style)) {
        YELLOWS.lastIndex = 0;
        el.setAttribute('style', style.replace(YELLOWS, mapColor));
      }
    }

    if (el.hasAttribute && (el.hasAttribute('fill') || el.hasAttribute('stroke'))) {
      ['fill', 'stroke'].forEach(function (attr) {
        var v = el.getAttribute(attr);
        if (v && YELLOWS.test(v)) {
          YELLOWS.lastIndex = 0;
          el.setAttribute(attr, mapColor(v));
        }
      });
    }
  }

  function walk(root) {
    if (!root) return;
    paint(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('[style], [fill], [stroke]').forEach(paint);
    }
  }

  function run() {
    walk(document.querySelector('#Itg-testimonial-section'));
    walk(document.querySelector('#Itgeekscarousel'));
    walk(document.querySelector('.itg-wgt-header'));
    walk(document.querySelector('#Itgeeks-review-form'));
    document
      .querySelectorAll(
        '[id*="trustyy"], [id*="tra_carousel"], [id*="tra_review"], [id*="tra_photo"], [id*="tra_star"], [class*="Itgeeks"], [class*="itg-wgt"], [class*="trusty-star"], [class*="Trustyy"]'
      )
      .forEach(walk);
  }

  var scheduled = null;
  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      run();
    });
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  var obs = new MutationObserver(schedule);
  obs.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'fill', 'stroke']
  });
})();
